export function jsonParse(jsonString: string) {
  try {
    return JSON.parse(jsonString);
  } catch (error) {
    console.error("JSON Parse Error: ", error);
    return null;
  }
}
